/**********************************
 * Settings
 **********************************/
import { createResetStore } from "@/utils/data/createResetStore.js";

/**********************************
 * Global UI Store Definition
 **********************************/
export const useGlobalUIStore = defineStore(
  "globalUIStore",
  createResetStore(() => {
    const isLoading = ref(false); // 화면을 전부 덮는 로딩 컴포넌트의 상태
    const isModalOpen = ref(false); // 모달 열림 상태
    const toastMessage = ref(""); // 토스트 메시지
    const showToast = ref(false); // 토스트 표시 상태

    // 로딩 상태 관리 -----------------
    const setLoading = (_param) => {
      isLoading.value = _param;
    };

    // 모달 상태 관리 -----------------
    const setModalOpen = (_param) => {
      isModalOpen.value = _param;
    };

    // 토스트 메시지 표시 -----------------
    const showToastMessage = (_message, _duration = 3000) => {
      toastMessage.value = _message;
      showToast.value = true;

      setTimeout(() => {
        showToast.value = false;
        toastMessage.value = "";
      }, _duration);
    };

    // 토스트 메시지 숨기기 -----------------
    const hideToastMessage = () => {
      showToast.value = false;
      toastMessage.value = "";
    };

    return {
      // States
      isLoading,
      isModalOpen,
      toastMessage,
      showToast,

      // Actions
      setLoading,
      setModalOpen,
      showToastMessage,
      hideToastMessage,
    };
  }),
);

// 개발모드에서 store HMR 활성화
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useGlobalUIStore, import.meta.hot));
}
